/* Ela Teila 2026-09-23 - dovanu kortele.
   1) Nominaluose rodo tikra rinkos kaina; formatas imamas is pacios temos kainos.
   2) Lietuviskoje versijoje laisko nuotrauka pakeicia lietuviska.
   3) 2026-09-29: galiojimo terminas pagal rinka (zr. VALIDITY).
   Preke atpazistama pagal <gift-card-recipient>. Jokiu ID ar sekciju numeriu. */
(function () {
  var MAP = null;

  var IMG_FROM = /gift-card-email\.png(\?v=\d+)?/g;
  var IMG_TO = 'gift-card-email-lt_2.png?v=1790178860';

  /* 2026-09-29 GALIOJIMAS PAGAL RINKA.
     Sablone parasyta JAV versija ("No expiry date" / "termino nera").
     Visoms kitoms salims (LT, UK, ES) rodoma: 6 menesiai nuo isigijimo.
     JAV - be termino (to reikalauja JAV istatymas). Salis imama is Shopify.country.
     Jei keisis tekstai sablone - pataisyti ir cia (kaire puse turi sutapti raide raide). */
  var VALIDITY = [
    ['No. Ela Teila Gift Cards have no expiry date.', 'Yes. Ela Teila Gift Cards are valid for 6 months from purchase.'],
    ['No expiry date.', '6 months from purchase.'],
    ['Ne. Ela Teila dovanų kuponai galiojimo termino neturi.', 'Taip. Ela Teila dovanų kuponai galioja 6 mėnesius nuo įsigijimo.'],
    ['termino nėra.', '6 mėnesiai nuo įsigijimo.']
  ];

  function isUs() {
    return !!(window.Shopify && window.Shopify.country === 'US');
  }

  function applyValidity() {
    if (isUs()) return;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue;
      if (!t) continue;
      for (var i = 0; i < VALIDITY.length; i++) {
        if (t.indexOf(VALIDITY[i][0]) !== -1) {
          t = t.split(VALIDITY[i][0]).join(VALIDITY[i][1]);
        }
      }
      if (t !== n.nodeValue) n.nodeValue = t;
    }
  }

  function isGiftCard() {
    return !!document.querySelector('gift-card-recipient');
  }

  function isLt() {
    return /^lt/i.test(document.documentElement.lang || '');
  }

  function swapImages() {
    if (!isLt()) return;
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      var s = im.getAttribute('src');
      if (s && s.indexOf('gift-card-email.png') !== -1) {
        im.setAttribute('src', s.replace(IMG_FROM, IMG_TO));
      }
      var ss = im.getAttribute('srcset');
      if (ss && ss.indexOf('gift-card-email.png') !== -1) {
        im.setAttribute('srcset', ss.replace(IMG_FROM, IMG_TO));
      }
    }
    var srcs = document.querySelectorAll('source[srcset]');
    for (var j = 0; j < srcs.length; j++) {
      var v = srcs[j].getAttribute('srcset');
      if (v && v.indexOf('gift-card-email.png') !== -1) {
        srcs[j].setAttribute('srcset', v.replace(IMG_FROM, IMG_TO));
      }
    }
  }

  function priceSample() {
    var el = document.querySelector('#main .price');
    if (!el) return null;
    var c = el.cloneNode(true);
    var hid = c.querySelectorAll('.visually-hidden');
    for (var i = 0; i < hid.length; i++) { hid[i].parentNode.removeChild(hid[i]); }
    var txt = (c.textContent || '').replace(/\s+/g, ' ').trim();
    if (!txt) return null;
    var m = txt.match(/\d[\d., \s]*\d|\d/);
    if (!m) return null;
    return { text: txt, num: m[0] };
  }

  function selectedCents() {
    var s = document.querySelector('script[data-variant]');
    if (!s) return null;
    try {
      var v = JSON.parse(s.textContent);
      return v && typeof v.price === 'number' ? v.price : null;
    } catch (e) { return null; }
  }

  function makeFormatter() {
    var sp = priceSample();
    var cents = selectedCents();
    if (sp && cents !== null) {
      var dm = sp.num.match(/([.,])(\d{2})$/);
      var dec = dm ? dm[1] : null;
      return function (c2) {
        var whole = Math.floor(c2 / 100);
        var frac = c2 % 100;
        var num = dec ? (whole + dec + ('0' + frac).slice(-2)) : String(Math.round(c2 / 100));
        return sp.text.replace(sp.num, num);
      };
    }
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null;
    if (!cur) return null;
    return function (c2) {
      try {
        return new Intl.NumberFormat('en', { style: 'currency', currency: cur }).format(c2 / 100);
      } catch (e) { return null; }
    };
  }

  function swap(el) {
    if (!el || !MAP) return;
    var t = (el.textContent || '').trim();
    if (!t) return;
    var v = MAP[t];
    if (v && v !== t) el.textContent = v;
  }

  function applyPrices() {
    if (!MAP) return;
    var list = document.querySelectorAll('.block-swatch__item, .combo-box__option-item, .select__selected-value, .product-form__option-value');
    for (var i = 0; i < list.length; i++) swap(list[i]);
  }

  function apply() {
    applyPrices();
    swapImages();
    applyValidity();
  }

  function load(done) {
    var parts = location.pathname.split('/products/');
    if (parts.length < 2) { done(); return; }
    var handle = parts[1].split('/')[0].split('?')[0];
    if (!handle) { done(); return; }
    var x = new XMLHttpRequest();
    x.open('GET', parts[0] + '/products/' + handle + '.js', true);
    x.onload = function () {
      if (x.status === 200) {
        var d = null;
        try { d = JSON.parse(x.responseText); } catch (e) { d = null; }
        var fmt = d && d.variants ? makeFormatter() : null;
        if (fmt) {
          var m = {};
          for (var i = 0; i < d.variants.length; i++) {
            var v = d.variants[i];
            var key = String(v.title == null ? '' : v.title).trim();
            var pretty = fmt(v.price);
            if (key && pretty) m[key] = pretty;
          }
          MAP = m;
        }
      }
      done();
    };
    x.onerror = function () { done(); };
    x.send(null);
  }

  function start() {
    if (!isGiftCard()) return;
    swapImages();
    applyValidity();
    load(function () {
      apply();
      try {
        new MutationObserver(function () { apply(); }).observe(document.body, { childList: true, subtree: true, characterData: true });
      } catch (e) {}
      document.addEventListener('shopify:section:load', apply);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
